import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { io } from "socket.io-client";

import MapApp from "./MapApp";
import Loading from "Components/Loading/Loading";

const SOCKET_URL = process.env.REACT_APP_URL_SOCKET;
const nameSocket = "/tracking";

const Main = ({ clientCode }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [taxiData, setTaxiData] = useState([]);
  const socketRef = useRef(null);
  const intervalRef = useRef(null); // Reference for the interval

  // Function to fetch taxi data
  const fetchTaxiData = async () => {
    const url = `${SOCKET_URL}/taxis/${clientCode}`;
    try {
      const res = await axios.get(url);
      setTaxiData(res?.data?.taxis || []);
    } catch (error) {
      console.error("Error fetching taxi data:", error.message);
    }
  };

  useEffect(() => {
    // Create socket connection
    socketRef.current = io(`${SOCKET_URL}${nameSocket}`, {
      auth: { token: "TOKEN_AUTH" },
    });

    const socket = socketRef.current;

    socket.on("connect", async () => {
      console.log("Connected to Socket.IO", socket.id);
      setIsLoading(true); // Show loading state while data is being fetched

      // Fetch data immediately upon connection
      await fetchTaxiData();

      // Set interval to fetch data every 2 seconds
      if (!intervalRef.current) {
        intervalRef.current = setInterval(fetchTaxiData, 2000);
      }
    });

    socket.on("connect_error", (error) => {
      console.error("Connection error:", error);
      setIsLoading(false);
    });

    socket.on("disconnect", () => {
      console.log("Disconnected from Socket.IO");
      setIsLoading(false);
      // Clear the interval on disconnect
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    });

    // Cleanup on unmount
    return () => {
      // Clear interval on component unmount
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      // Disconnect socket
      socket.disconnect();
      console.log("Socket disconnected");
    };
  }, [clientCode]);

  return <MapApp taxis={taxiData} />;
};

export default Main;
